"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingService = void 0;
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const restservice_1 = require("../../shared/services/restservice");
const http_1 = require("@angular/common/http");
const constants_1 = require("../../shared/constants");
class BillingService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.url = '/rest-api/account/bill/v1/history';
        this.paymentUrl = '/rest-api/account/payment/v1/history';
        this.fundsUrl = '/rest-api/account/sub/v1/funds/';
        this.ppaccountSummaryUrl = '/rest-api/account/bill/v1/details';
        this.getBillUrl = '/rest-api/account/bill/v1/location/';
        this.paperlessBilling = '/rest-api/account/bill/v1/paperless/update';
        this.getAutopayMethodUrl = '/rest-api/account/autopay/v1/details';
        this.paymentEligiblityUrl = '/rest-api/account/payment/v1/extend/eligibility';
        this.extendPayment = '/rest-api/account/payment/v1/extend';
        this.giftCardUrl = '/rest-api/account/payment/giftcard/v1/checkBalance/';
        this.giftCardSaveUrl = '/rest-api/account/payment/giftcard/v1/save/';
        this.sessionIdUrl = '/rest-api/profile/v1/riskSessionId/';
        this.getbbReportUrl = '/rest-api/account/bill/v1/business/display/report';
        this.getSchedulePaymentUrl = '/rest-api/account/scheduledPayment/v1/details';
        this.cancelSchedulePaymentUrl = '/rest-api/account/scheduledPayment/v1/cancel';
        this.kountUrl = '/rest-api/account/payment/v1/paymentcollector';
        this.recentTransactionsUrl = '/rest-api/account/v1/transactionDetails';
        this.prorationUrl = '/rest-api/account/renewal/v1/proration/';
        // CIP-451
        this.paymentScheduleDateUrl = '/rest-services/web-wirelessaccount-services/v1/account/scheduled-payments/details/';
        this.savePayPalAutopayDetailsUrl = '/rest-api/account/autopay/v1/savePayPal';
        this.emitAutopayDetails = new rxjs_1.BehaviorSubject([]);
        this.autopayDetailsEmitted$ = this.emitAutopayDetails.asObservable();
    }
    getGiftCardBalanceDetails(giftCardNumber, giftCardPin) {
        const inputArgs = new http_1.HttpParams().set('giftCardNo', giftCardNumber)
            .set('pin', giftCardPin);
        return this.post(this.giftCardUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    saveGiftCard(content) {
        return this.post(this.giftCardSaveUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getBillingHistory() {
        if (this.billingHistoryData) {
            return rxjs_1.of(this.billingHistoryData);
        }
        else {
            return this.get(this.url).pipe(operators_1.map((data) => {
                this.billingHistoryData = data;
                return data;
            }));
        }
    }
    getPaymentHistory() {
        return this.get(this.paymentUrl).pipe(operators_1.map((data) => data));
    }
    getFundsDetails(subscrptionId) {
        return this.get(this.fundsUrl + subscrptionId).pipe(operators_1.map((data) => data));
    }
    getPPaccountSummary(refreshResponse) {
        if (this.billingSummary && !refreshResponse) {
            return rxjs_1.of(this.billingSummary);
        }
        else if (this.acctSummaryObservable && !refreshResponse) {
            return this.acctSummaryObservable;
        }
        else {
            this.acctSummaryObservable = this.get(this.ppaccountSummaryUrl).pipe(operators_1.map((data) => {
                this.acctSummaryObservable = null;
                this.billingSummary = data;
                return data;
            }), operators_1.share());
            return this.acctSummaryObservable;
        }
    }
    getBill(cycleEndDate, equipmentAccountNumber, invoiceNumber) {
        let url = this.getBillUrl + cycleEndDate;
        if (equipmentAccountNumber) {
            url = url + '?accountNumber=' + equipmentAccountNumber;
            if (invoiceNumber) {
                url += '&invoiceNumber=' + invoiceNumber;
            }
        }
        return this.get(url).pipe(operators_1.map((data) => data));
    }
    updateBillingMethod(paperlessBilling) {
        const inputArgs = new http_1.HttpParams().set('eBill', paperlessBilling);
        return this.post(this.paperlessBilling, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getAutoPayType(cacheResponse) {
        if (this.autopayData && cacheResponse !== true) {
            return rxjs_1.of(this.autopayData);
        }
        else if (this.autopayObservable) {
            return this.autopayObservable;
        }
        else {
            this.observable = null;
            this.autopayData = null;
            this.autopayObservable = this.get(this.getAutopayMethodUrl).pipe(operators_1.map((data) => {
                this.emitAutopayDetails.next(data);
                this.autopayObservable = null;
                this.autopayData = data;
                return data;
            }), operators_1.share());
            return this.autopayObservable;
        }
    }
    getAutoPayDetails(isTokenizedCard) {
        return this.get(this.getAutopayMethodUrl + '?isTokenizedCard=' + isTokenizedCard).pipe(operators_1.map((data) => data));
    }
    getPaymentExtensionEligiblity() {
        return this.get(this.paymentEligiblityUrl).pipe(operators_1.map((data) => data));
    }
    getExtendPaymentDate() {
        return this.post(this.extendPayment, {}).pipe(operators_1.map((data) => data));
    }
    getSessionId() {
        return this.get(this.sessionIdUrl).pipe(operators_1.map((data) => data));
    }
    getBBbillingReport() {
        return this.get(this.getbbReportUrl).pipe(operators_1.map((data) => data));
    }
    getScheduledPayment() {
        return this.get(this.getSchedulePaymentUrl).pipe(operators_1.map((data) => data));
    }
    cancelScheduledPayment() {
        return this.delete(this.cancelSchedulePaymentUrl).pipe(operators_1.map((data) => data));
    }
    getPaymentCollector() {
        return this.get(this.kountUrl).pipe(operators_1.map((data) => data));
    }
    /**
    CIP:274 - Get Recent Transactions
    */
    getRecentTransactions() {
        return this.get(this.recentTransactionsUrl).pipe(operators_1.map((data) => data));
    }
    /**
    Prepaid-SDR - Get proration
    */
    getProrationByDate(renewalDate) {
        return this.get(this.prorationUrl + renewalDate).pipe(operators_1.map((data) => data));
    }
    /*
    *CIP-451 Scheduled Payment Enhancement - get payment schedule date
    */
    getPaymentScheduleDate() {
        return this.get(this.paymentScheduleDateUrl).pipe(operators_1.map((data) => data));
    }
    creditCardMaskAndType(cardValue, isAutopayForm) {
        for (const cardNumberFormat of constants_1.creditCardNumberFormats) {
            if (cardNumberFormat.cardIINRanges.some((startNum) => cardValue.startsWith(startNum)) ||
                this.checkIfIINIsInRange(cardNumberFormat.cardIINRanges, cardValue)) {
                return cardNumberFormat;
            }
        }
    }
    checkIfIINIsInRange(iin, cardValue) {
        let isInRange = false;
        for (const range of iin) {
            if (range.includes('-')) {
                const rangeSplit = range.split('-');
                const rangeLength = rangeSplit[0].length;
                const intCardValue = parseInt(cardValue.substring(0, rangeLength), 10);
                const intRangeStart = parseInt(rangeSplit[0], 10);
                const intRangeEnd = parseInt(rangeSplit[1], 10);
                if (intRangeStart <= intCardValue && intCardValue <= intRangeEnd) {
                    isInRange = true;
                    break;
                }
            }
        }
        return isInRange;
    }
    /*
    * PayPal Autopay - stage the paypal details for autopay usage
    */
    savePayPalAutopayDetails(paymentNonce, paymentEmail) {
        const inputArgs = new http_1.HttpParams().set('paymentNonce', paymentNonce).set('paymentEmail', paymentEmail);
        return this.post(this.savePayPalAutopayDetailsUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
}
exports.BillingService = BillingService;
//# sourceMappingURL=billing.service.js.map